<template>
  <label :class="classNames" class="base-radio">
    <input
      :checked="shouldBeChecked"
      :value="value"
      :disabled="disabled"
      v-bind="$attrs"
      type="radio"
      @change="updateInput"
    />
    <div class="base-radio__box"></div>
    <span v-if="$slots.default" class="base-radio__label">
      <slot v-bind="{ checked: shouldBeChecked }"></slot>
    </span>
  </label>
</template>
<script>
export default {
  inheritAttrs: false,
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {},
    // eslint-disable-next-line vue/require-prop-types
    modelValue: {},
    theme: {
      type: String,
      default: "default",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldBeChecked() {
      return this.modelValue === this.value;
    },
    classNames() {
      const { shouldBeChecked, theme, disabled } = this;
      return [
        {
          "is-checked": shouldBeChecked,
          "is-disabled": disabled,
          "with-label": this.$slots.default,
          bordered: theme === "bordered",
        },
        `theme-${theme}`,
      ];
    },
  },
  methods: {
    updateInput() {
      this.$emit("change", this.value);
    },
  },
};
</script>

<style lang="less" scoped>
@app-checkbox-bg: #fff;
@app-checkbox-size: 20px;
//@app-checkbox-border-color: @input-border-color;
@app-checkbox-border-color: @gray-color;
//@app-checkbox-border-width: @input-border-width;
@app-checkbox-border-width: 1px;
@app-checkbox-focus-border-color: @primary-color;
//@app-checkbox-border-radius: @input-border-radius;
@app-checkbox-border-radius: 20px;
@app-checkbox-icon-color: #fff;

.base-radio {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  transform: translateZ(0);
  user-select: none;
  cursor: pointer;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    opacity: 0;
  }

  &__box {
    display: inline-block;
    position: relative;
    flex-grow: 0;
    flex-shrink: 0;
    width: @app-checkbox-size;
    height: @app-checkbox-size;
    background-color: @app-checkbox-bg;
    transition: background 0.3s, border 0.3s;
    cursor: pointer;
    vertical-align: middle;
    transform: translateZ(0);
    border: @app-checkbox-border-width solid @app-checkbox-border-color;
    border-radius: 50%;
    overflow: hidden;
    flex-grow: 0;
    flex-shrink: 0;

    &:hover {
      background-color: darken(@app-checkbox-bg, 1%);
      border-color: @app-checkbox-focus-border-color;
    }

    &:active {
      background-color: @app-checkbox-focus-border-color;
    }

    &::before {
      content: "";
      display: block;
      width: @app-checkbox-size - 10px;
      height: @app-checkbox-size - 10px;
      background-color: #fff;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      transition: background-color 0.3s;
    }
  }

  &__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 13px;
    margin-top: -7px;
    margin-left: -6px;
    transform-origin: left top;
    transition: opacity 0.3s, transform 0.3s;
    opacity: 0;
    transform: rotateZ(-45deg);
    fill: @app-checkbox-icon-color;
  }

  &.is-checked &__box &__icon {
    opacity: 1;
    transform: rotateZ(0deg);
  }

  &.is-checked &__box {
    border-color: @app-checkbox-focus-border-color;

    &::before {
      background-color: @app-checkbox-focus-border-color;
    }
  }

  &__label {
    margin-left: 0.55em;
    display: inline-block;
    vertical-align: middle;
  }
  .with-label &__box {
    margin-right: 0.25em;
  }

  &.with-label {
    display: inline-flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  input:focus + &__box {
    border-color: @app-checkbox-focus-border-color;
  }

  &.is-disabled {
    cursor: initial;
  }

  &.is-disabled &__box {
    //border-color: @gray-200;
    border-color: @gray-color;
    //background-color: @gray-200;
    background-color: @gray-color;
    cursor: initial;

    &::before {
      //background-color: @gray-100;
      background-color: @gray-color;
    }
  }

  &.is-disabled.is-checked &__box::before {
    //background-color: @gray-500;
    background-color: @base-color;
  }

  &.is-disabled &__icon {
    //fill: @gray-300;
    fill: @gray-color;
  }

  &.theme-bordered {
    //border: 1px solid @gray-200;
    border: 1px solid @gray-color;
    border-radius: @border-radius-xs;
    padding: 10px;
    transition: background 0.3s, border 0.3s;
    display: flex;
    width: 100%;

    &:hover {
      background-color: darken(@app-checkbox-bg, 1%);
      border-color: @app-checkbox-focus-border-color;
    }

    &.is-checked.theme-bordered {
      border-color: @app-checkbox-focus-border-color;
      background-color: #f5fafc;
    }
  }
}
</style>
